
<div class="dashboard-content-sec " >
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="saveClient()" [formGroup]="form" >
        <div class="row form-section">
            <div class="col">
                <div class="card mb-0">
                    <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
                    <div class="card-title">
                        <!-- <h5 class="fa fa-building">
                          {{ this.title }}
                        </h5> -->

                        <a id="client-expand" style="color:black" 
                            data-toggle="collapse" class="p-2 fa fa-expand-alt" href="#clientTable" (click)="swapIcon($event)">
                            {{ClientNameCtrl.value}} Profile</a>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="100">Save</button>
                        </div>
                    </div>

                    <div class="card-form" id="clientTable" class="collapse show">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2 control-label">Active</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event)" [checked]="active == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="activeLabel">{{active}}</label> 
                            </div>
                        </div>
   
                        <div class="form-row">
                            <label class="col-sm-2 control-label" for="ClientName">Client Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="ClientName"  id="ClientName"
                                    name="ClientName" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="1" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="ClientNameCtrl.invalid && (ClientNameCtrl.dirty || ClientNameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="ClientNameCtrl.errors.required">
                              <span>Client Name is required.</span>
                           </div>
                           <div *ngIf="ClientNameCtrl.errors.minlength">
                              Client Name must be at least 2 characters long.
                           </div>
                        </div>


                        <div class="form-row" *ngIf="!isPartner && !isClient">
                            <label class='col-sm-2'>Partner</label>
                            <div class='form-group col-sm-4'>
                                <select id="ID" name="ID" class="form-control" (change)="changeServices()"
                                        formControlName="ID" tabindex="2">
                                    <!-- <option selected value="">Please select Client</option> -->
                                    <option id="{{partner.ID}}" value="{{partner.ID}}" 
                                            *ngFor="let partner of partners">{{partner.CompanyName}}
                                    </option>

                                </select>

                                <div *ngIf="PartnerIDCtrl.invalid && (PartnerIDCtrl.dirty || PartnerIDCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Partner is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2" for="ContactName">Contact Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="ContactName"  id="ContactName"
                                name="ContactName" type="text" 
                                required minlength="2"
                                class="form-control" 
                                tabindex="3" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="ContactNameCtrl.invalid && (ContactNameCtrl.dirty || ContactNameCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="ContactNameCtrl.errors.required">
                                <span>Contact Name is required.</span>
                            </div>
                            <div *ngIf="ContactNameCtrl.errors.minlength">
                                Contact Name must be at least 2 characters long.
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="Telephone">Phone Number</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Telephone"  id="Telephone"
                                    name="Telephone" type="text" 
                                    required 
                                    class="form-control" 
                                    tabindex="4" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="TelephoneCtrl.invalid && (TelephoneCtrl.dirty || TelephoneCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="TelephoneCtrl.errors.required">
                                <span>Telephone is required.</span>
                            </div>
                        </div>
                            

                        <div class="form-row">
                            <label class="col-sm-2" for="Address1">Address line 1</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Address1" type="text" 
                                    class="form-control" id="Address1" tabindex="5" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="Address1Ctrl.invalid && (Address1Ctrl.dirty || Address1Ctrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="Address1Ctrl.errors.required">
                              <span>Address is required.</span>
                           </div>
                           <div *ngIf="Address1Ctrl.errors.minlength">
                            Address must be at least 2 characters long.
                           </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="Address2">Address line 2</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Address2" type="text" 
                                   class="form-control" id="Address2" tabindex="6" placeholder="">
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="City">City</label>
                            <div class="form-group col-sm-4">
                                    <input formControlName="City"  id="City"
                                    name="City" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="7" placeholder="">
                            </div>
                        </div>   
                        <div *ngIf="CityCtrl.invalid && (CityCtrl.dirty || CityCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="CityCtrl.errors.required">
                                <span>City is required.</span>
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="State">State</label>
                            <div class="col-sm-1">
                                    <input formControlName="State"  id="State"
                                    name="State" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="8" placeholder="">
                            </div>
                            <div *ngIf="StateCtrl.invalid && (StateCtrl.dirty || StateCtrl.touched)"
                                class="invalid-feedback">
                                <div *ngIf="StateCtrl.errors.required">
                                    <span>State is required.</span>
                                </div>
                            </div>


                            <div class="col-sm-1">&nbsp;</div>
                            <label class="col-sm-1" for="Zip">Zip</label>
                            <div class="form-group col-sm-1">
                                <input formControlName="PostalCode"  id="PostalCode"
                                    name="PostalCode" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="9" placeholder="">
                            </div>
                        </div>   
                        <div *ngIf="PostalCodeCtrl.invalid && (PostalCodeCtrl.dirty || PostalCodeCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="PostalCodeCtrl.errors.required">
                                <span>Zip is required.</span>
                            </div>
                        </div>                        

                        <div class="form-row">
                            <label class="col-sm-2" for="BusinessSummary">Business Summary</label>
                            <div class="form-group col-sm-8">
                                <textarea formControlName="BusinessSummary" type="text" rows="5"
                                    class="form-control" id="BusinessSummary" tabindex="10" placeholder="">
                                </textarea>                                
                            </div>
                        </div>
                        <div *ngIf="BusinessSummaryCtrl.invalid && (BusinessSummaryCtrl.dirty || BusinessSummaryCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="BusinessSummaryCtrl.errors.required">
                                <span>Business Summary Notes</span>
                            </div>
                        </div>


                        <div class="dashboard-content-sec mt-4" *ngIf="canManageConnectorKey && !isNewClient">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:220px" class="p-2 fa fa-expand-alt"
                                        href="#adpConnectorDiv" (click)="swapIcon($event)">
                                        ADP Connector</a>
                                    </div>
                                </div>

                                <div id="adpConnectorDiv" class="collapse show">
                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">ADP Connector key</label>
                                        <div class="form-group col-sm-6">
                                            <label class="col-form-label text-break">{{ connectorKeyHint ? connectorKeyMask + connectorKeyHint : 'Not generated' }}</label>
                                            <div *ngIf="connectorKeyHint && connectorKeyCreatedAt" class="small text-muted">
                                                Generated {{ connectorKeyCreatedAt | date:'mediumDate' }}<ng-container *ngIf="connectorKeyCreatedByName"> by {{ connectorKeyCreatedByName }}</ng-container>
                                            </div>
                                        </div>
                                        <div class="form-group col-sm-2">
                                            <a href="javascript:void(0)" class="btn btn-default"
                                               [class.disabled]="connectorKeySaving"
                                               (click)="!connectorKeySaving && generateConnectorKey()">
                                                {{ connectorKeyHint ? 'Regenerate' : 'Generate' }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="dashboard-content-sec mt-4" *ngIf="isSuperAdmin && marketplaceSubscription">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:220px" class="p-2 fa fa-expand-alt"
                                        href="#marketplaceSubscriptionDiv" (click)="swapIcon($event)">
                                        Marketplace Subscription</a>
                                    </div>
                                </div>

                                <div id="marketplaceSubscriptionDiv" class="collapse show">
                                    <div class="alert alert-warning" role="alert" *ngIf="marketplaceSubscription.PossibleDuplicateOf">
                                        Possible duplicate. This account was created by an ADP purchase with no connector key,
                                        and an active client named
                                        <a [attr.href]="'/admins/client/' + marketplaceSubscription.PossibleDuplicateOf" target="_blank" rel="noopener" class="text-primary font-weight-bold" style="text-decoration: underline;">{{marketplaceSubscription.PossibleDuplicateOfName}}</a>
                                        already exists. If they are the same company, move the ADP subscription to the original
                                        account and deactivate this one.
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Provider</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.Provider}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Subscription ID</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.SubscriptionId}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Organisation OID</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.SubscriptionOrgOid}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Edition</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.Edition}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Term</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.Term}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Seats</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.Seats}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Status</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.Status}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Consent</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.ConsentStatus || 'Not given'}}</label>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <label class="col-sm-2 control-label">Consent at</label>
                                        <div class="form-group col-sm-4">
                                            <label class="col-form-label">{{marketplaceSubscription.ConsentAt ? (marketplaceSubscription.ConsentAt | date) : 'Not given'}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="dashboard-content-sec mt-4" *ngIf="isSuperAdmin && marketplaceSubscription">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:220px" class="p-2 fa fa-expand-alt"
                                        href="#employeesDiv" (click)="swapIcon($event)">
                                        Employees</a>
                                    </div>
                                    <div style='width: 140px' class="d-inline-block">
                                        <a href="javascript:void(0)" class="btn btn-default"
                                           [class.disabled]="employeesSyncing"
                                           (click)="!employeesSyncing && syncEmployeesNow()">
                                            {{ employeesSyncing ? 'Syncing...' : 'Sync now' }}
                                        </a>
                                    </div>
                                    <div class="d-inline-block ml-2">
                                        <span>Last sync: {{ employeeSync?.last_sync_at ? (employeeSync.last_sync_at | date:'medium') : 'Never' }}
                                            <ng-container *ngIf="employeeSync?.last_sync_status"> ({{ employeeSync.last_sync_status }})</ng-container>
                                        </span>
                                        <div *ngIf="employeeSync?.last_error" class="text-danger" style="font-size: 0.8em;">
                                            {{ employeeSync.last_error }}
                                        </div>
                                    </div>
                                </div>

                                <div id="employeesDiv" class="table-responsive collapse show">
                                    <div class="form-row">
                                        <div class="form-group col-sm-6">
                                            <label>
                                                <input type="checkbox" [checked]="showInactiveEmployees"
                                                       (change)="toggleShowInactiveEmployees($event)" />
                                                Show inactive
                                            </label>
                                        </div>
                                    </div>
                                    <table id="employeesTable" class="table user-table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Work email</th>
                                                <th>Department</th>
                                                <th>Worker type</th>
                                                <th>Hire date</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let emp of employees">
                                                <tr id="employee-row{{emp.id}}">
                                                    <td>{{emp.first_name}} {{emp.last_name}}</td>
                                                    <td>{{emp.work_email}}</td>
                                                    <td>{{emp.department}}</td>
                                                    <td>{{emp.worker_type}}</td>
                                                    <td>{{emp.hire_date ? (emp.hire_date | date) : ''}}</td>
                                                    <td>{{emp.employment_status}}</td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                        <ng-container *ngIf="!employeesLoading && employees?.length == 0">
                                            <tr><td colspan="6">No employees synced yet</td></tr>
                                        </ng-container>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div class="dashboard-content-sec mt-4">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:180px" class="p-2 fa fa-expand-alt"
                                        href="#statesDiv" (click)="swapIcon($event)">
                                        {{clientStates?.length}} States & Employees</a>
                        
                                    </div>
                                    <div style='width: 140px' class="d-inline-block">
                                            <a data-toggle="collapse" href="#newStateRow" 
                                               class="fa fa-address-book btn btn-default "
                                               (click)="expandTable('statesDiv')">
                                                Add State
                                            </a>                        
                                        </div>       
                        
                                </div>
                        
                                <div id="statesDiv" class="table-responsive collapse">
                                    <table id="statesTable" class="table user-table table-striped">
                                        <thead>
                                            <tr>
                                                <th >State</th>
                                                <th >Employee Count</th>
                                                <th >Remove</th >
                                            </tr>
                                        </thead>
                        
                                        <tbody>
                                            <ng-container *ngFor="let state of clientStates">
                                                <tr id="state-row{{state.ID}}">
                                                    <td>
                                                        <select id="state{{state.ID}}"  class="custom-select" 
                                                                style="width: 100px" (change)="updateState(state.ID)"> 
                                                            <option value="{{st.ID}}"
                                                                [selected]="st.Code == state.state"
                                                                *ngFor="let st of states">{{st?.Code}}                                                                
                                                            </option>
                                                    </select>
                                                    </td>
                                                    
                                                    <td>
                                                        <input type="number" id="stateEmp{{state.ID}}" class="form-control" style="width: 100px" 
                                                            value="{{ state.count }}" (change)="updateState(state.ID)"/>
                        
                                                    </td>
                                            
                                                    <td>
                                                        <div class="d-inline-block">
                                                            <a id="del-state{{state.ID}}" title="Remove" class="btn fa fa-times"
                                                            (click)="deleteState(state.ID)"> </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            
                                            <tr class="collapse" id="newStateRow">
                                                <td >
                                                    <select id="newState"  (change)="checkForAutoSave()"
                                                    class="custom-select new-state" style="width: 100px">
                                                        <option value="{{st.ID}}" 
                                                            *ngFor="let st of states">{{st?.Code}}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td >
                                                    <input id="newStateCount" (change)="checkForAutoSave()"  
                                                    class="form-control new-state" style="width: 100px" type="number"/>
                                                </td>
                                                <td>
                                                    <div class="d-inline-block">
                                                        <a title="Cancel" class="btn fa fa-times" (click)="clearState()"> </a>
                                                    </div>
                                                </td>
                        
                                            </tr>
                                        </tbody>
                                        <ng-container *ngIf="clientStates?.length == 0">
                                            <tr><td colspan="3">No Result Found</td></tr>
                                        </ng-container>                                 
                       
                                    </table>
                        
                                </div>
                            </div>
                        </div>
                        
                        

                        

                        <div class="dashboard-content-sec mt-4">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:180px" class="p-2 fa fa-expand-alt" 
                                        href="#servicesDiv" (click)="swapIcon($event)">
                                        {{services?.length}} Services</a>
                        
                                    </div>
                                    <div style='width: 140px' class="d-inline-block" *ngIf="!isClient">
                                            <a data-toggle="collapse" href="#newServiceRow" 
                                               class="fa fa-address-book btn btn-default "
                                               (click)="expandTable('servicesDiv')">
                                                Add Service
                                            </a>                        
                                        </div>       
                        
                                </div>
                        
                                <div id="servicesDiv" class="table-responsive collapse">
                                    <table id="serviceTable" class="table user-table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Service</th>
                                                <th>Description</th>
                                                <th>Effective Date</th> 
                                                <th>Expiration Date</th>
                                                <th>Cancel</th>
                                            </tr>
                                        </thead>
                        
                                        <tbody>
                                            <ng-container *ngFor="let serv of services">
                                                <tr id="service-row{{serv.ID}}" [ngClass]="{ 'text-muted' : serv.ExpirationDate }">
                                                    <td>
                                                        {{ serv.Code }}
                                                    </td>                                                   
                                                    <td>
                                                        {{ serv.Description }}
                                                    </td>
                                                    <td >
                                                        {{ serv.EffectiveDate }}
                                                    </td>
                                                    <td>{{ serv.ExpirationDate }}</td>
                                                
                                                    <td>
                                                        <div class="d-inline-block" *ngIf="!isClient">
                                                            <a id="del-service{{serv.ID}}" title="Remove" class="btn fa fa-times"
                                                            (click)="deleteService(serv.ID)"> </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            
                                            <tr class="collapse" id="newServiceRow">
                                                <td >
                                                    <select id="newService"  (change)="serviceAutoSave()"
                                                    class="custom-select new-service" style="width: 200px">
                                                        <option value="{{se.Code}}" 
                                                            *ngFor="let se of servicesOffered">{{se?.Code}}
                                                        </option>
                                                    </select>
                                                </td>
                                                <td>
                                                    {{ newServiceDescription }}
                                                </td>
                                                <td >
                                                    <div class="input-group">
                                                        <input class="form-control" placeholder="yyyy-mm-dd"
                                                               name="dp" id="newServiceDate" 
                                                               (focus)="d.open()"
                                                               data-container="body"
                                                               (change)="serviceAutoSave()"
                                                               (dateSelect)="serviceAutoSave()"
                                                               ngbDatepicker #d="ngbDatepicker"
                                                               style="width: 200px ">
                                                        <div class="input-group-append">
                                                          <button class="btn btn-outline-secondary calendar fa fa-calendar" 
                                                              (click)="d.toggle()" type="button"></button>
                                                        </div>
                                                    </div>                                                
                                                </td>
                                                <td >
                                                    &nbsp;
                                                </td>
                                                <td>
                                                    <div class="d-inline-block">
                                                        <a title="Cancel" class="btn fa fa-times" (click)="clearService()"> </a>
                                                    </div>
                                                </td>
                        
                                            </tr>
                                        </tbody>
                                        <ng-container *ngIf="services?.length == 0">
                                            <tr><td colspan="3">No Result Found</td></tr>
                                        </ng-container>                        
                       
                                    </table>
                        
                                </div>
                            </div>
                        </div>
                        
                        



                    </div>
                </div>
            </div>
        </div>
    </form>

</div>





<!-- <div *ngIf="this.id > 0">
    <app-services-list [client_id]="this.id"></app-services-list>
</div> -->

<div *ngIf="this.id > 0" class="mt-4">
    <app-user-list [client_id]="this.id"></app-user-list>
</div>

<div *ngIf="this.id > 0" class="mt-4">
    <app-roleprofile-list [client_id]="this.id" (submitted)="saveClient( true )"></app-roleprofile-list>
</div>

<div style="height: 150px;">
    &nbsp;
</div>

